import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { MessageModule } from 'primeng/message';
import { SymPageHeaderComponent } from '@/shared/ui';

@Component({
  selector: 'app-model-selection',
  standalone: true,
  imports: [CommonModule, ButtonModule, TagModule, MessageModule, SymPageHeaderComponent],
  templateUrl: './model-selection.component.html',
  styleUrls: ['./model-selection.component.scss']
})
export class ModelSelectionComponent {

  constructor(private router: Router) { }

  navigateToModel(modelType: string): void {
    switch(modelType) {
      case 'oportunidad':
        this.router.navigate(['/tender/ideal-client/oportunidad']);
        break;
      case 'oferta':
        this.router.navigate(['/tender/ideal-client/oferta']);
        break;
      default:
        console.error('Tipo de modelo no reconocido:', modelType);
    }
  }
}